import 'css-chunksrc/client/common/layout/logo/styles.scss';export default {
  "logo": "_logo_1gbtz_1",
  "baseLogo": "_baseLogo_1gbtz_12",
  "input": "_input_1gbtz_17",
  "overlay": "_overlay_1gbtz_21",
  "icon": "_icon_1gbtz_34",
  "loader": "_loader_1gbtz_44"
};